module.exports = __webpack_public_path__ + "assets/img/block-hover-9d23abed.png";